import React, { useEffect, useState } from 'react';
import { Box, Button, VStack, Text, theme  } from '@bpba/ui-components';

import { useMutation} from "@apollo/client";
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { Result } from './Result';

import { ResultError } from './ResultError';
import { useParams } from 'react-router-dom';

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ConfirmacionEntradasRQ } from '../rest/models/ConfirmacionEntradasRQ';
import { postConfirmacionEntradas } from '../rest/mutations/postConfirmacionEntradas';
import { Mutations } from '../rest/Mutations';

const ConfirmacionEntradasComponente: React.FC = () => {
    
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    
    const { codigoUnico: codigoEvento } = useParams<string>();
    const [postConfirmacionEntradasAPI, { loading: loadingConfirmacionEntradas }] = useMutation<Mutations>(postConfirmacionEntradas);
    
    const [casoRespuesta, setCasoRespuesta] = useState<any>();
    const [tituloRespuesta, setTituloRespuesta] = useState<string>("");
    const { executeRecaptcha } = useGoogleReCaptcha();

    const ConfirmarCodigo = async () => {
                const  token=executeRecaptcha && await executeRecaptcha('ConfirmarEntradas');
                
                let datos: ConfirmacionEntradasRQ = {
                    "googleToken": token,
                    "codigoUnico": codigoEvento? Number(codigoEvento):0
                    
                };
                postConfirmacionEntradasAPI({ variables: { input: datos } }).then(response => {
                    
                    if(response.data && response.data?.confirmacionEntradasRQ.caso.toUpperCase()!=='error'.toUpperCase()){
                        setCasoRespuesta(<></>);
                        setTituloRespuesta("");
                        if(response.data?.confirmacionEntradasRQ.caso==="1"){
                                setCasoRespuesta(<Text fontSize={"18px"} tabIndex={0}>Lo sentimos, no saliste sorteado.</Text>);
                                setTituloRespuesta(response.data?.confirmacionEntradasRQ.titulo+"!");
                        }else if(response.data?.confirmacionEntradasRQ.caso==="2"){
                                setCasoRespuesta(<><Text fontSize={"18px"} tabIndex={0}>Tus entradas se vencieron.</Text><Text fontSize={"18px"} tabIndex={0}>Tu premio no fue confirmado en el horario que te solicitamos y fue adjudicado a otra persona.</Text> 
                                <Text fontSize={"18px"} tabIndex={0}>Seguí participando de los próximos sorteos para volver a ganar.</Text> </>);
                                setTituloRespuesta(response.data?.confirmacionEntradasRQ.titulo+"!");
                        }else if(response.data?.confirmacionEntradasRQ.caso.includes("/")){
                                setCasoRespuesta(<><Text fontSize={"18px"} tabIndex={0}>Tus 2 entradas para el show <b>{response.data?.confirmacionEntradasRQ.caso}</b>, están confirmadas. Te las enviaremos 24 h antes del evento. Revisá el mail con el que te inscribiste.</Text>

                                <Text fontSize={"18px"} tabIndex={0}>Gracias por participar de los sorteos de Cuenta DNI.</Text>
                                
                                <Text fontSize={"18px"} tabIndex={0}>Conocé los términos y condiciones haciendo clic <a style={{ textDecoration: "none", color: theme.colors.secondary[1], fontWeight: "bold" }} href='https://www.bancoprovincia.com.ar/CDN/Get/TYC_LOSPIOJOS'>acá</a></Text></>);
                                setTituloRespuesta(response.data?.confirmacionEntradasRQ.titulo);
                        }

                    }else{
                        setMensajeErrorPostProspecto("Ha ocurrido un error intente mas tarde.");
                    }
                    
                }).catch((e: any) => {
                    setMensajeErrorPostProspecto("Ha ocurrido un error intente mas tarde.");
                } );
            
        
      
      
        
    }
    
    useEffect(() => {
        executeRecaptcha && ConfirmarCodigo();
        
      }, [!executeRecaptcha,!ConfirmarCodigo]);


      const handleReset = () => {
          
          window.open('/', '_blank')
      };
  
      if (mensajeErrorPostProspecto !== "") return (
          <Result handleReset={handleReset}>
              <ResultError message={mensajeErrorPostProspecto}></ResultError>
          </Result>
      );
    if (loadingConfirmacionEntradas) return <SpinnerCajas />;





    return (

        <Box>
            <VStack>
                <Text
              fontSize={['26px', '26px', '36px', '36px']}
              color={theme.colors.primary[0]}
              lineHeight={['33px', '33px', '43px', '43px']}
              textAlign={['center', 'center', 'start', 'start']}
              tabIndex={0}
            >
                    {tituloRespuesta}
                </Text>
                <VStack mt={"10px"}>
                    {casoRespuesta}
                </VStack>

                {casoRespuesta && <VStack mt={"20px"}>
                    <Button type="submit" variant="secondary" style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'} onClick={() => handleReset()} >Ir a la web</Button>
                        
                </VStack>}
                
            </VStack>

        </Box>

    )

};



export default ConfirmacionEntradasComponente;
